
export function buildSubFolderTree (folderArray, parentId, level = 1) {
  // build list of folders nested inside provided folderId
  const found = [];
  folderArray.forEach((item) => {
    if (item.parent_id === parentId) {
      found.push({ ...item, level });
      // search for nested folders
      found.push(...buildSubFolderTree(folderArray, item.id, level + 1));
    }
  });
  return found;
}

export function buildSubFolderIds (folderArray, folderId) {
  return folderArray.reduce((result, item) => {
    if (item.type === `folder`) {
      if (item.id === folderId) {
        result.push(item.id);
      }
      if (item.parent_id === folderId) {
        result.push(...buildSubFolderIds(folderArray, item.id));
      }
    }
    return result;
  }, []);
}

export function sortByTitle(objA, objB) {
  if (objA.title < objB.title) {
    return -1;
  }
  if (objA.title > objB.title) {
    return 1;
  }
  return 0;
}

export function sortByName(objA, objB) {
  if (objA.name < objB.name) {
    return -1;
  }
  if (objA.name > objB.name) {
    return 1;
  }
  return 0;
}

export const allFoldersFilterOption = {
  label: `All folders`,
  value: `all`,
  icon: ``,
  iconFill: ``
};
export const ownedFoldersFilterOption = {
  label: `Owned by me`,
  value: `owned`,
  icon: `folder`,
  iconFill: `blue`,
};
export const sharedWithFoldersFilterOption = {
  label: `Shared with me`,
  value: `shared`,
  icon: `folder-shared`,
  iconFill: `black`,
};
export const folderFilterOptions = [
  allFoldersFilterOption,
  ownedFoldersFilterOption,
  sharedWithFoldersFilterOption,
];

export function allFolderFilter (folder) {
  // return all folders
  return folder.type === `folder`;
}

export function ownedFolderFilter (folder) {
  // return folders owned by me
  return folder.owned_by_me;
}

export function sharedWithFolderFilter (folder) {
  // return folders shared with me
  return folder.shared && !folder.owned_by_me;
}

export function getFolderFilterFunc (filterValue) {
  // get filter function from provided filter value
  if (filterValue === ownedFoldersFilterOption.value) {
    return ownedFolderFilter;
  }
  if (filterValue === sharedWithFoldersFilterOption.value) {
    return sharedWithFolderFilter;
  }
  return allFolderFilter;
}

export function searchFolderFunc (folder, searchTerm) {
  return folder.title.toLowerCase().includes(searchTerm);
}

export function levelFolderFunc (folder, level) {
  return folder.level === level;
}

export function organiseFolderData (folderData) {
  // split data into folders and content
  const dataTypes = folderData.reduce((dataType, item) => {
    if (item.type === `folder`) {
      dataType.folders.push(item);
    } else {
      dataType.content.push(item);
    }
    return dataType;
  }, { folders: [], content: [], idTree: {} });

  // build folder structure and sort all items alphabetically
  const folderStructure = buildFolderStructure(dataTypes.folders);
  return {
    data: [
      ...folderStructure.data,
      ...dataTypes.content.sort(sortByTitle),
    ],
    idTree: folderStructure.idTree,
  };
}

export function buildFolderStructure (folderData) {
  // pull out all the folders shared with me
  const sharedFolderIds = folderData.reduce((folders, item) => {
    if (item.type === `folder` && !item.owned_by_me) {
      folders.push(item.id);
    }
    return folders;
  }, []);

  // sort the folders alphabetically
  const orderedFolders = folderData.sort(sortByTitle);

  // build the folder structure
  let isTopLevel;
  return orderedFolders.reduce((tree, folder) => {
    isTopLevel = folder.parent_id === null;
    // build folder ID tree for each folder
    tree.idTree[folder.id] = new Set(buildSubFolderIds(orderedFolders, folder.id));

    if (!folder.owned_by_me) {
      /*
      * A user can share a folder that is not one of their "top-level" folders
      * i.e. the folder shared has a parent ID that is NOT null
      * In this situation there is no folder in our list with an ID that would match
      * the shared folders parent ID
      * For our list of folders, this shared folder is a "pseudo-parent" folder
      * i.e. it should appear at the "top-level" in our list
      * */
      isTopLevel = isTopLevel || !sharedFolderIds.includes(folder.parent_id);
    }
    if (isTopLevel) {
      // calculate nested level for folders contained in top-level folder
      tree.data.push({ ...folder, level: 0 });
      tree.data.push(...buildSubFolderTree(orderedFolders, folder.id, 1));
    }

    return tree;
  }, { data: [], idTree: {} });
}

export function buildObjectMap (objs) {
  // map the object ID against the object data
  return objs.reduce((map, obj) => {
    map[obj.id] = obj;
    return map;
  }, {});
}




// WEBPACK FOOTER //
// ./library/app/utils/organiseFolders.js